import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CookieConsentButton from './CookieConsentButton';

const Footer: React.FC = () => {
    const { t } = useTranslation();

    // Check if cookie banner is enabled via build flag (default: false)
    const isCookieBannerEnabled = import.meta.env.VITE_ENABLE_COOKIE_BANNER === 'true';

    return (
        <footer className="border-t border-border bg-background/80 backdrop-blur-sm">
            <div className="container mx-auto px-4 py-6 text-sm text-muted-foreground flex flex-col sm:flex-row items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                    <img src="/minifil-150.png" alt="Minifil" className="h-6 w-6" />
                    <span className="font-medium text-foreground">{t('app.title')}</span>
                    <span className="text-muted-foreground">© {new Date().getFullYear()}</span>
                </div>
                <nav className="flex items-center gap-4">
                    <Link to="/terms" className="hover:text-foreground underline-offset-4 hover:underline transition-colors">
                        {t('legal.terms.link', 'Terms of Service')}
                    </Link>
                    <Link to="/privacy" className="hover:text-foreground underline-offset-4 hover:underline transition-colors">
                        {t('legal.privacy.link', 'Privacy Policy')}
                    </Link>
                    {isCookieBannerEnabled && <CookieConsentButton />}
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
